import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import Utils from 'frilans-finans/utils/utils';
import InvoiceActivityStatus from '../../../components/invoice-activity-status/invoice-activity-status';
import Ellipsis from '../../../components/svg/ellipsis';
import ShowMore from '../../../components/show-more/show-more-invoice';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

export class ErrandRow extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    toggleShowMoreList: PropTypes.func.isRequired,
    resetShowMoreList: PropTypes.func.isRequired,
    showMoreList: PropTypes.object.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.isAwaitingApproval = this.isAwaitingApproval.bind(this);
    this.showMoreList = this.showMoreList.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.setWrapperRefMobile = this.setWrapperRefMobile.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef (node) {
    this.wrapperRef = node;
  }

  setWrapperRefMobile (node) {
    this.wrapperRefMobile = node;
  }

  handleClickOutside (event) {
    if ((this.wrapperRef && !this.wrapperRef.contains(event.target)) &&
      (this.wrapperRefMobile && !this.wrapperRefMobile.contains(event.target))) {
      if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
        this.props.resetShowMoreList();
      }
    }
  }

  showMoreList () {
    this.props.toggleShowMoreList(this.props.invoice.id);
  };

  renderShowMore (showMoreList, route) {
    if (showMoreList) {
      return <ShowMore
        invoice={this.props.invoice}
        invoiceRoute={route}
        user={this.context.user}
      />;
    }
  }

  isAwaitingApproval () {
    return this.props.invoice.status === 1;
  }

  render () {
    let route = '/economy/invoices/' + this.props.invoice.id;
    let showMoreList = +this.props.showMoreList.invoiceId === +this.props.invoice.id
      ? this.props.showMoreList.show
      : false;

    return (
      <div className='errand-flex-row'>
        <div className='errand-flex-row-content'>
          <div className='errand-flex-title-container'>
            <div className='errand-flex-title'>
              <p className='errand-title'>{this.props.invoice.customer.name}</p>
              <p className='errand-subtitle'>
                {this.props.invoice.amount} {proxyCounterpart('SEK')} {proxyCounterpart('EXCL_VAT')}
              </p>
              <p className='errand-subtitle'><Translate content='CREATED_DATE'
                date={Utils.formatDate(this.props.invoice.createdAt)}/></p>
            </div>
            <div
              ref={this.setWrapperRefMobile}
              className='errand-flex-trailing hide-until-mobile'
            >
              {this.renderShowMore(showMoreList, route)}
              <div onClick={this.showMoreList}>
                <Ellipsis
                  colorSchema='primary'
                  fill={showMoreList}
                />
              </div>
            </div>
          </div>
          <div className='errand-activity-status'>
            <InvoiceActivityStatus
              invoice={this.props.invoice}
              user={this.context.user}
              containerStyle=' dashboard'
            />
          </div>
          <div
            ref={this.setWrapperRef}
            className='errand-flex-trailing hide-mobile'
          >
            {this.renderShowMore(showMoreList, route)}
            <div onClick={this.showMoreList}>
              <Ellipsis
                colorSchema='primary'
                fill={showMoreList}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrandRow;



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/errand-table/errand-row.js
 **/